export const FETCH_ACTIVITIES = 'fetchActivities';
export const LOG_ACTIVITY = 'fetchActivities';
